import { getUrlQuerysection } from "../../../../helpers";
import { useContext, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { useGetCashFlowReport } from "../../../../hooks/api/queries";
import { ToastContext } from "../../../../hooks/context";
import { useSelector } from "react-redux";
import { useStoreCurrency } from "../../../../hooks/useStoreCurrency";

export const useAccountingCashFlow = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const { storeHasMultipleCurrency } = useStoreCurrency();
  const { businessDetails } = useSelector(
    (state) => state.profileDetailsReducer,
  );
  const { storeList } = useSelector((state) => state.profileDetailsReducer);
  const triggerToast = useContext(ToastContext);

  const [startDate, setStartDate] = useState(
    searchParams.get("start_date") || null,
  );
  const [endDate, setEndDate] = useState(searchParams.get("end_date") || null);
  const [currentStore, setCurrentStore] = useState(
    storeHasMultipleCurrency
      ? searchParams.get("store_id") || storeList?.[0]?.id
      : "",
  );
  const queries = getUrlQuerysection();

  const {
    isLoading: isLoadingReport,
    data: reportData,
    refetch: fetchCashFlowReport,
  } = useGetCashFlowReport({ queries, enabled: false });

  const setDateFilter = (data) => {
    const { startDate, endDate } = data;
    searchParams.set("start_date", startDate);
    searchParams.set("end_date", endDate);
    setStartDate(startDate);
    setEndDate(endDate);
    setSearchParams(searchParams, { replace: true });
  };

  const filterByStoreId = (storeId) => {
    setCurrentStore(storeId);
    if (storeId === "ALL_STORES" || storeId === "")
      searchParams.delete("store_id");
    else searchParams.set("store_id", storeId);
    setSearchParams(searchParams, { replace: true });
  };

  const onGenerateReport = () => {
    if (!startDate || !endDate) {
      triggerToast("Please select a date range first", "warning");
      return;
    }

    fetchCashFlowReport();
  };

  return {
    startDate,
    endDate,
    businessName: businessDetails?.business_name,
    reportData: reportData?.data || null,
    isLoadingReport,
    storeList,
    storeHasMultipleCurrency,
    currentStore,
    setDateFilter,
    filterByStoreId,
    onGenerateReport,
  };
};
